// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"b045e1fe","320":"a738c8a3","476":"fa6e30d1","670":"42b67244","707":"a3d089da","723":"234d1fcf","835":"f3cbe3d8","858":"d0189320"}[chunkId] + ".chunk.js";
};